import React from 'react';

export const LocationMap = () => (
    <section id="location-map-section">
        <div className="column is-12-desktop is-12-tablet is-12-mobile left-column">
            <img alt="location-map" src="imgs/conference_map.jpg" />
        </div>
    </section>
);

export default LocationMap;
